import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { startUpdateFechaFinal } from '../../../actions/suscripciones';

const EditarFechaFinal = ({ suscripcion, onUpdate }) => {
  const dispatch = useDispatch();
  const { colores } = useSelector(state => state.ui);
  const inputRef = useRef(null);
  
  const getInitialFecha = () => {
    if (suscripcion?.fechaRenovaciónPeriodo) {
      const date = new Date(suscripcion.fechaRenovaciónPeriodo);
      const day = String(date.getUTCDate()).padStart(2, '0');
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const year = date.getUTCFullYear();
      return `${day}/${month}/${year}`;
    }
    return '';
  };
  
  const [fechaFinal, setFechaFinal] = useState(getInitialFecha());
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    setFechaFinal(getInitialFecha());
  }, [suscripcion?.fechaRenovaciónPeriodo]);

  const parseFecha = (fechaStr) => {
    // Acepta formato DD/MM/YYYY o DD-MM-YYYY
    const separators = ['/', '-'];
    let parts = null;
    
    for (const sep of separators) {
      if (fechaStr.includes(sep)) {
        parts = fechaStr.split(sep);
        break;
      }
    }
    
    if (!parts || parts.length !== 3) {
      return null;
    }
    
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);
    
    if (isNaN(day) || isNaN(month) || isNaN(year)) {
      return null;
    }
    
    // Validar rango
    if (day < 1 || day > 31 || month < 1 || month > 12 || year < 1900 || year > 2100) {
      return null;
    }
    
    return { day, month, year };
  };

  const handleGuardar = async () => {
    if (!fechaFinal || fechaFinal.trim() === '') {
      setFechaFinal(getInitialFecha());
      return;
    }

    const fechaParsed = parseFecha(fechaFinal.trim());
    
    if (!fechaParsed) {
      // Fecha inválida, restaurar valor original
      setFechaFinal(getInitialFecha());
      return;
    }

    setGuardando(true);
    
    // Convertir fecha a ISO 8601 con hora 23:59:59
    // Formato esperado: "2024-12-31T23:59:59.000Z"
    const { day, month, year } = fechaParsed;
    const fechaISO = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T23:59:59.000Z`;

    const result = await dispatch(startUpdateFechaFinal(suscripcion._id, fechaISO));
    
    setGuardando(false);
    
    if (result && result.ok) {
      // Actualizar el formato mostrado
      setFechaFinal(`${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`);
      if (onUpdate && result.suscripcion) {
        onUpdate(result.suscripcion);
      }
    } else {
      // Si falla, restaurar el valor original
      setFechaFinal(getInitialFecha());
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleGuardar();
    } else if (e.key === 'Escape') {
      setFechaFinal(getInitialFecha());
      inputRef.current?.blur();
    }
  };

  const handleBlur = () => {
    handleGuardar();
  };

  return (
    <input
      ref={inputRef}
      type="text"
      value={fechaFinal}
      onChange={(e) => setFechaFinal(e.target.value)}
      onKeyDown={handleKeyDown}
      onBlur={handleBlur}
      disabled={guardando}
      placeholder="DD/MM/YYYY"
      style={{
        padding: '0.25rem 0.5rem',
        border: 'none',
        borderRadius: '0',
        fontSize: 'inherit',
        width: 'auto',
        minWidth: '100px',
        maxWidth: '120px',
        cursor: guardando ? 'not-allowed' : 'text',
        opacity: guardando ? 0.6 : 1,
        backgroundColor: 'var(--colorSecundario)',
        outline: 'none',
        fontFamily: 'inherit',
        color: 'inherit'
      }}
      onClick={(e) => e.stopPropagation()}
    />
  );
};

export default EditarFechaFinal;

